import React from 'react'
import { observer } from 'mobx-react'
import { Modal, Button } from 'react-bootstrap'
import { i18nTranslate, checkMysiteOrPersonalOffer } from 'src/utils'
import { multipleSubscriptionContainer, cartContainer } from 'src/models'
import { CheckoutNuskinIcon } from 'src/views/components/Icons/CheckoutNuSkinIcon'
import { getProcessingDateDetails, capitalizeFirstLetters } from 'src/deps'
import { ConfirmationModalProductDetails } from './ConfirmationModalProductDetails'
import { checkIsNativeApp } from 'src/utils/reactNativeAppUtils'
import './styles.scss'

@observer
class SubscriptionConfirmedModal extends React.Component {
  renderNavigationButtonsForSubscription = () => {
    const manageSubscriptionText = i18nTranslate(
      'productCard.manageSubscriptionButtonText',
      'Manage subscription',
      { isNextGenTranslations: true }
    )

    const continueShoppingText = i18nTranslate(
      'cartCreateNewSubscriptionComponent.addToSubscription.continueShoppingButtonText',
      'Continue shopping',
      { isNextGenTranslations: true }
    )

    const cartButton = i18nTranslate(
      'cartCreateNewSubscriptionComponent.addToSubscription.returnToCartButtonText',
      'Return to cart',
      { isNextGenTranslations: true }
    )

    const {
      handleRedirectionToSubscription = function () {},
      handleRedirectionToHomePage = function () {},
      selectedSubscriptionGroup = {},
      handleRedirectionToCartPage = function () {},
      subscriptionId = '',
    } = this.props
    const contextText = checkMysiteOrPersonalOffer() || ''
    const isNativeApp = checkIsNativeApp() || false

    return (
      <div className="d-flex justify-content-between navigation-button-list">
        {contextText === '' && !isNativeApp && (
          <Button
            className="manage-subscription-button"
            data-testid="manage-subscription-button"
            onClick={() => handleRedirectionToSubscription(subscriptionId)}>
            {manageSubscriptionText}
          </Button>
        )}
        {!isNativeApp && (
          <Button
            className="continue-subscription-button"
            data-testid="continue-subscription-button"
            onClick={handleRedirectionToHomePage}>
            {continueShoppingText}
          </Button>
        )}
        {isNativeApp && (
          <Button
            className="cart-subscription-button"
            data-testid="isNativeApp-cart-subscription-button"
            onClick={handleRedirectionToCartPage}>
            {cartButton}
          </Button>
        )}
      </div>
    )
  }

  renderNavigationButtonsForOTP = () => {
    const {
      handleRedirectionToCheckoutPage = function () {},
      handleRedirectionToCartPage = function () {},
    } = this.props

    const checkoutButton = i18nTranslate(
      'cartCreateNewSubscriptionComponent.addToSubscription.proceedToCheckoutButtonText',
      'Proceed to checkout',
      { isNextGenTranslations: true }
    )
    const cartButton = i18nTranslate(
      'cartCreateNewSubscriptionComponent.addToSubscription.returnToCartButtonText',
      'Return to cart',
      { isNextGenTranslations: true }
    )
    const totalCartItem = cartContainer?.cartCount || 0

    const totalItemCountText = '(' + totalCartItem + ')'

    const isToShowIconInfo = application.isMobile ? 'd-none' : ''

    return (
      <div className="d-flex justify-content-between navigation-button-list">
        <Button
          className="cart-subscription-button"
          data-testid="cart-subscription-button"
          onClick={handleRedirectionToCartPage}>
          {cartButton}
        </Button>
        <Button
          className="checkout-subscription-button"
          data-testid="checkout-subscription-button"
          onClick={handleRedirectionToCheckoutPage}>
          <span className={`${isToShowIconInfo} mr-1`}>
            <CheckoutNuskinIcon
              className="view-cart-nuskin"
              width="24px"
              height="24px"
              fill="#ffffff"
            />
          </span>
          <span>{checkoutButton}</span>
          <span className={`${isToShowIconInfo} ml-1`}>
            {totalItemCountText}
          </span>
        </Button>
      </div>
    )
  }

  renderSubscriptionProductDetails = () => {
    const { itemInfo = [] } =
      multipleSubscriptionContainer.subscriptionAddedResponse
    return <ConfirmationModalProductDetails cartSubscriptionList={itemInfo} />
  }

  render() {
    const {
      handleSubscriptionConfirmedModalClose,
      showModal = false,
      isCartHasOneTimeProducts = false,
      cartSubscriptionItems = [],
      subscriptionId = '',
    } = this.props
    const {
      processingDay,
      nextOrderCreationDate,
      lastOrderProcessedDate,
      name: subscriptionName = '',
    } = multipleSubscriptionContainer.selectedSubscriptionGroupDetails

    const dateDetails = getProcessingDateDetails({
      processingDay,
      lastOrderProcessedDate,
      nextOrderCreationDate,
    })

    const nextOrderProcessingFullDate = dateDetails?.orderProcessDate
    const { itemInfo = [] } =
      multipleSubscriptionContainer.subscriptionAddedResponse

    const subscriptionConfirmedTitle = i18nTranslate(
      'subscriptionUpdatedModal.title',
      'Subscription updated',
      { isNextGenTranslations: true }
    )
    const modifiedSubscriptionName =
      capitalizeFirstLetters(subscriptionName) || ''

    const subscriptionItemsUpdatedText = i18nTranslate(
      'cartCreateNewSubscriptionComponent.addToSubscription.itemAddedSuccessfully',
      'Your items have been successfully added to %%subscription_name%%',
      { isNextGenTranslations: true }
    ).replace('%%subscription_name%%', modifiedSubscriptionName)

    const nextOrderDateText = i18nTranslate(
      'subscriptionUpdatedModal.processingDateCaption',
      'Next order date:',
      { isNextGenTranslations: true }
    )

    return (
      <Modal
        onHide={handleSubscriptionConfirmedModalClose}
        show={showModal}
        className="subscription-confirmed-modal-wrapper">
        <Modal.Header
          closeButton
          className="subscription-confirmed-modal-header">
          <Modal.Title className="subscription-confirmed-title">
            {subscriptionConfirmedTitle}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="subscription-confirmed-modal-body">
          <div className="subscription-confirmation-wrapper">
            <div className="subscription-confirmation-modal-title">
              {subscriptionItemsUpdatedText}
            </div>
            <div className="subscription-next-order-date">
              <span>{nextOrderDateText}</span>
              <span className="next-order-processing-date">
                {nextOrderProcessingFullDate}
              </span>
            </div>
            <div className="subscription-details-wrapper">
              {this.renderSubscriptionProductDetails()}
            </div>
          </div>
          <div className="navigation-button-wrapper">
            {isCartHasOneTimeProducts
              ? this.renderNavigationButtonsForOTP()
              : this.renderNavigationButtonsForSubscription()}
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export { SubscriptionConfirmedModal }
export default SubscriptionConfirmedModal
